import { DwNewRouteKeyService, DwRoutingMessageService } from '@webdpt/framework';
import { FxDapHttpClient } from 'app/implementation/shared/fx-http-client';
import { FxModalService } from 'app/implementation/shared/components/fx-modal/fx-modal.service';
import { TranslateService } from '@ngx-translate/core';
import { DwModalService } from 'ng-quicksilver';
var FxMperCellRendererComponent = /** @class */ (function () {
    function FxMperCellRendererComponent(router, dwMessage, http, fxModalService, translateService, dwModalService) {
        this.router = router;
        this.dwMessage = dwMessage;
        this.http = http;
        this.fxModalService = fxModalService;
        this.translateService = translateService;
        this.dwModalService = dwModalService;
        this.keyObj = {};
        this.infoList = [];
    }
    // refresh(params: any): boolean {
    //   throw new Error("Method not implemented.");
    // }   //原fresh
    FxMperCellRendererComponent.prototype.refresh = function (params) {
        // throw new Error("Method not implemented.");
    }; //by dinghao 0704
    FxMperCellRendererComponent.prototype.agInit = function (params) {
        var _this = this;
        this.params = params;
        this.mper = [this.params.data[this.params.field[0]], this.params.data[this.params.field[1]]];
        this.params.key.forEach(function (item) {
            var _a;
            Object.assign(_this.keyObj, (_a = {}, _a[item] = _this.params.data[item], _a));
        });
    };
    FxMperCellRendererComponent.prototype.dataInit = function () {
        var _this = this;
        this.infoOption = {
            tableName: this.params.tableName,
            keyValue: this.keyObj
        };
        // console.log('参数不全', this._infoOption);
        if (!this.infoOption.tableName || !this.infoOption.keyValue) {
            console.log('参数不全');
            return;
        }
        this.http.post('A/IACommonService/getDynamicInfo', { param: this.infoOption }).subscribe(function (result) {
            console.log('异动资讯', result);
            _this.infoList = result.data;
        });
    };
    FxMperCellRendererComponent.prototype.change = function (event) {
        console.log(event);
        if (event) {
            this.dataInit();
        }
    };
    return FxMperCellRendererComponent;
}());
export { FxMperCellRendererComponent };
